<template>
  <span
    id="articles-actions"
  >
    <b-dropdown
      left
      data-test="articles-actions-dropdown-button"
      variant="plain"
      toggle-class="text-decoration-none"
      no-caret
      size="sm"
    >
      <template v-slot:button-content>
        <i class="fa-light fa-ellipsis-v" />
      </template>
      <b-dropdown-item
        v-if="isViewType('Editor')"
        data-test="add-article"
        @click="openArticleModal"
        :disabled="isReadOnly()"
      >
        Add an article
      </b-dropdown-item>
      <b-dropdown-item
        v-if="isViewType('Showcase')"
        data-test="select-only-draft-items"
        @click="selectOnlyDraft"
        :disabled="isReadOnly()"
      >
        Select Only Draft Items
      </b-dropdown-item>
      <b-dropdown-item
        v-if="isViewType('Editor')"
        data-test="submit-all-draft-items-for-approval"
        @click="approveDraftItems"
        :disabled="isReadOnly()"
      >
        Submit All Draft Items For Approval
      </b-dropdown-item>
      <b-dropdown-item
        v-if="isManagedCampaign && (isViewType('Setup') || isViewType('Editor'))"
        data-test="view-feed"
        @click="viewFeed"
        :disabled="isReadOnly()"
      >
        View feed
      </b-dropdown-item>
    </b-dropdown>

    <b-modal
      id="AddArticleModal"
      title="Add new articles"
      size="lg"
      hide-footer
      v-if="isViewType('Editor')"
    >
      <content-info
        ref="contentInfo"
        @setNotValidForNavigation="updateSubmitValidation"
      />
      <b-button
        :disabled="!validToSubmit"
        size="lg"
        variant="primary"
        data-test="submit-button"
        class="ml-auto"
        :class="{ 'btn-loading': isLoading }"
        @click="submitContentItems"
      >
        Submit
      </b-button>
    </b-modal>
  </span>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

import ContentInfo from '@/modules/content/components/ContentInfo';
import suppressibleBox from '@/core/mixins/suppressibleBox';

export default {
  name: 'ArticlesActions',
  mixins: [
    suppressibleBox,
  ],
  components: {
    ContentInfo,
  },
  data() {
    return {
      isLoading: false,
      validToSubmit: false,
    };
  },
  methods: {
    ...mapActions('content', {
      fetchArticles: contentTypes.FETCH_ARTICLES,
      APPROVE_DRAFT_ITEMS: contentTypes.APPROVE_DRAFT_ITEMS,
    }),
    openArticleModal() {
      this.$root.$emit('bv::show::modal', 'AddArticleModal');
    },
    updateSubmitValidation(emitType, valid) {
      if (emitType === 'submit') this.validToSubmit = !valid;
    },
    selectOnlyDraft() {
      // This is only for Showcase Currently not required but left here in case componenet is later used for showcase...
      // this.$emit('selectOnlyDraft');
    },
    approveDraftItems() {
      this.boxOk(
        'Information',
        'All ad content goes through an approvals process to make sure it\'s safe and appropriate for users. Approvals can take up to 2 working days.',
        'suppressSendForApprovalDialog',
      ).then(() => {
        this.APPROVE_DRAFT_ITEMS(this.feedId);
        this.fetchArticles();
      });
    },
    viewFeed() {
      window.open(`${process.env.VUE_APP_SMARTCONSOLE_HOST}/content-sources/${this.feedId}/content-items`, '_blank');
    },
    submitContentItems() {
      this.isLoading = true;
      this.$refs.contentInfo.onSubmit();
      setTimeout(() => {
        this.$root.$emit('bv::hide::modal', 'AddArticleModal');
        this.isLoading = false;
      }, 2000);
    },
  },
  computed: {
    ...mapState('campaigns', [
      'order',
      'viewType',
    ]),
    ...mapState('content', [
      'creative',
      'feedId',
    ]),
    ...mapGetters('campaigns', {
      isManagedCampaign: campaignTypes.GET_IS_MANAGED_CAMPAIGN,
      isViewType: campaignTypes.GET_IS_VIEW_TYPE,
      isReadOnly: campaignTypes.GET_IS_READ_ONLY,
    }),
  },
};
</script>
<style lang="scss">
</style>
